import { Organization } from "@common/types/organization";
import { noop } from "lodash";
import {
    createContext,
    FC,
    useCallback,
    useContext,
    useMemo,
    useState,
} from "react";
import { ChildrenProps } from "types";
import { useWorkspaceContext } from "./workspaceContext";

interface OrganizationContextType {
    activeOrganization: Organization | null;
    changeActiveOrganization: (organization: Organization | null) => void;
}

export const OrganizationContext = createContext<OrganizationContextType>({
    activeOrganization: null,
    changeActiveOrganization: noop,
});

export const OrganizationProvider: FC<ChildrenProps> = ({ children }) => {
    const [activeOrganization, setActiveOrganization] =
        useState<Organization | null>(null);
    const { changeActiveWorkspace } = useWorkspaceContext();

    const changeActiveOrganization = useCallback(
        (organization: Organization | null) => {
            setActiveOrganization(organization);
            changeActiveWorkspace(null);
        },
        [changeActiveWorkspace],
    );

    const value = useMemo(
        () => ({
            activeOrganization,
            changeActiveOrganization,
        }),
        [activeOrganization, changeActiveOrganization],
    );

    return (
        <OrganizationContext.Provider value={value}>
            {children}
        </OrganizationContext.Provider>
    );
};

export function useOrganizationContext() {
    return useContext(OrganizationContext);
}
